var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{staticClass:"m-0 p-0 label",attrs:{"label":_vm.label,"dense":"","readonly":"","disabled":"","outlined":"","value":_vm.value}})
}
var staticRenderFns = []

export { render, staticRenderFns }